import logo from '../assets/jakcomfort-logo.png';

type Props = {
  compact?: boolean;
  light?: boolean;
};

export function BrandLogo({ compact = false, light = false }: Props) {
  return (
    <div className={`brand-logo ${compact ? 'brand-logo--compact' : ''} ${light ? 'brand-logo--light' : ''}`}>
      <img src={logo} alt="Logo JakComfort" />
      {!compact && (
        <div className="brand-logo__text">
          <strong><span>Jak</span>Comfort</strong>
          <small>Comfort in Every Move</small>
        </div>
      )}
    </div>
  );
}
